import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 * 实战列表
 * @param params
 * 
*/

export const practiceList = params => Http.get(`${baseUrl}/works/task`, { params })

/**
 * 新增实战
 * @param params
 * 
*/

export const addPractice = params => Http.post(`${baseUrl}/works/task`, params )

/**
 * 删除实战
 * @param ids
 * 
*/

export const delPractice = ids => Http.delete(`${baseUrl}/works/task/${ids}` )

/**
 * 实战信息
 * @param taskId
 * 
*/

export const practiceInfo = taskId => Http.get(`${baseUrl}/works/task/${taskId}` )

/**
 * 修改实战
 * @param params
 * 
*/

export const editPractice = params => Http.put(`${baseUrl}/works/task`, params )

/**
 * 实战库列表
 * @param params
 * 
*/

export const practiceBankList = params => Http.get(`${baseUrl}/works/task/store`, { params })

/**
 * 实战库新增实战
 * @param params
 * 
*/

export const bankAddPractice = params => Http.post(`${baseUrl}/works/task/store/${params.classId}`, params )

/**
 * 实战库删除实战
 * @param taskStoreIds
 * 
*/

export const bankDelPractice = taskStoreIds => Http.delete(`${baseUrl}/works/task/store/${taskStoreIds}` )

/**
 * 实战库实战信息
 * @param taskStoreId
 * 
*/

export const bankPracticeInfo = taskStoreId => Http.get(`${baseUrl}/works/task/store/${taskStoreId}` )

/**
 * 实战库修改实战
 * @param params
 * 
*/

export const bankEditPractice = params => Http.put(`${baseUrl}/works/task/store`, params )

/**
 * 实战库发布实战
 * @param params
 * 
*/

export const bankReleasePractice = params => Http.put(`${baseUrl}/works/task/store/release`, params )
